angular.module('directives').directive('enumerationCompare', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            diffs: "="
        },

        template: require('./enumerationCompare.html'),

        link: function (scope, iElement, iAttrs, ctrl) {

        },

        controller: ['$scope', function ($scope) {

        }]
    };
});
